var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"dense":"","masked":false,"value":_vm.value,"type":"tel","outlined":"","clearable":"","required":"","hide-details":_vm.errors.length ? false : true,"error-messages":_vm.errors,"placeholder":"Phone No."},on:{"click:clear":function($event){return _vm.$emit('input', null)},"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }